export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReENVW5pS1MtVVRGMTYtSEELIBa+fQ4Hn20gg51tAAoEAQAsDAEAAQAeN4EEPGEHIBMBvnufbAG+eAUJvwECAb5/g51yAb8NEAW/ETsCvxo=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniKS-UTF16-V.bcmap
// module id = 753
// module chunks = 3